import React from "react";
import { ThreeRow, TwoColumn, TwoRow } from "../../core/layouts";
import variables from "../../themes/base/styles/variables";
import useResponsive from "../../core/hooks/useResponsive";

export const DashboardGraphLayoutStyles = {
  bodyStyle: {
    display: variables.dFlex,
    spaceBetween: variables.spaceBetween,
    gap: variables.gapMediumSmall,
    width: variables.fullWidth,
  },
  sectionWidth: {
    width: variables.dashboardGraphLayoutSectionsWidth,
  },
  sectionStyle: {
    flex: 1,
    gap: variables.gapMediumSmall,
    overflow: variables.overflowHidden,
  },
  mobileBodyStyle: {
    gap: variables.mediumGap2,
  },
  mobileTopSection: {
    display: variables.dFlex,
    gap: variables.mediumGap2,
  },
  levelGraphStyle: {
    marginBottom: variables.marginBottomLevel4Graph,
  },
};
export default function DashboardGraphLayout({
  operationAuditGraph,
  totalCompleteAuditsGraph,
  gradingGraph,
  radarGraph,
  level2Graph,
  level3Graph,
  level4Graph,
  level5Graph,
}) {
  const responsive = useResponsive();

  return (
    <>
      {responsive?.isMd ? (
        <TwoColumn
          style={DashboardGraphLayoutStyles.bodyStyle}
          leftSectionStyle={DashboardGraphLayoutStyles.sectionWidth}
          leftSection={
            <ThreeRow
              style={DashboardGraphLayoutStyles.sectionStyle}
              topSection={operationAuditGraph}
              middleSection={radarGraph}
              bottomSection={
                <TwoRow
                  style={DashboardGraphLayoutStyles.sectionStyle}
                  topSection={level2Graph}
                  bottomSection={level4Graph}
                />
              }
            />
          }
          isRightFillSpace
          rightSectionStyle={DashboardGraphLayoutStyles.sectionWidth}
          rightSection={
            <ThreeRow
              style={DashboardGraphLayoutStyles.sectionStyle}
              topSection={totalCompleteAuditsGraph}
              middleSection={gradingGraph}
              bottomSection={
                <TwoRow
                style={DashboardGraphLayoutStyles.sectionStyle}
                topSection={level3Graph}
                bottomSection={level5Graph}
              />
                }
            />
          }
        />
      ) : (
        <ThreeRow
          style={DashboardGraphLayoutStyles.mobileBodyStyle}
          topSection={
            <ThreeRow
              style={DashboardGraphLayoutStyles.mobileTopSection}
              topSection={operationAuditGraph}
              middleSection={totalCompleteAuditsGraph}
              bottomSection={radarGraph}
            />
          }
          middleSection={gradingGraph}
          bottomSection={
            <TwoRow
              style={DashboardGraphLayoutStyles.sectionStyle}
              topSection={level2Graph}
              bottomSection={
                <ThreeRow
                  style={DashboardGraphLayoutStyles.sectionStyle}
                  topSection={level3Graph}
                  middleSection={level4Graph}
                  bottomSectionStyle={
                    DashboardGraphLayoutStyles.levelGraphStyle
                  }
                  bottomSection={level5Graph}
                />
              }
            />
          }
        />
      )}
    </>
  );
}
